export default {
  /*
   * index() lista las incidencias
   */
  index(params) {
    return Vue.http.get('tracking/incidences', params).then(response => response.data)
  }
}
